/* ════════════════════════════════════════════════════════════════
   Cellenium theme · scripts
   Cada componente tem um init(raiz) e é reiniciado quando a seção
   é recarregada no personalizador (evento shopify:section:load).
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var C = window.CELL || {};
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  /* largura útil (sem a barra de rolagem): alinha as seções divididas à grade */
  function medirVw() { document.documentElement.style.setProperty('--vw', document.documentElement.clientWidth + 'px'); }
  medirVw(); window.addEventListener('resize', medirVw);

  /* ── dinheiro no formato da loja (ex.: "R$ {{amount_with_comma_separator}}") ── */
  function money(cents) {
    var fmt = C.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    function num(n, dec, th, dc) {
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dc + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_period_and_space_separator': return num(cents, 2, ' ', '.');
        default: return num(cents, 2, '.', ','); /* amount_with_comma_separator */
      }
    });
  }
  function parcelaTxt(cents) {
    var n = C.parcelas || 12;
    return (C.strings.installments || 'ou [count]x de [amount]').replace('[count]', n).replace('[amount]', money(Math.round(cents * (C.parcelaFator || 1) / n)));
  }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ══════════ BARRA DE AVISOS ══════════ */
  function initAnnounce(root) {
    $$('[data-announce]', root).forEach(function (bar) {
      if (!once(bar, 'ok')) return;
      var items = $$('.ann-track p', bar), i = 0, n = items.length;
      if (n < 2) return;
      function show(k) { items[i].classList.remove('on'); i = (k + n) % n; items[i].classList.add('on'); }
      $('.js-ann-prev', bar).onclick = function () { show(i - 1); };
      $('.js-ann-next', bar).onclick = function () { show(i + 1); };
      setInterval(function () { if (!document.hidden) show(i + 1); }, parseInt(bar.dataset.delay, 10) || 5000);
    });
  }

  /* ══════════ HERO: imagens deslizando em loop ══════════
     O primeiro slide é clonado no fim; ao chegar nele, volta ao início sem
     animação, então o ciclo segue sempre no mesmo sentido. */
  function initHero(root) {
    $$('[data-hero]', root).forEach(function (hero) {
      if (!once(hero, 'ok')) return;
      var track = $('[data-hero-track]', hero), dotsBox = $('[data-hero-dots]', hero);
      var slides = Array.prototype.slice.call(track.children), n = slides.length, i = 0, timer = null, paused = false;
      var DELAY = parseInt(hero.dataset.delay, 10) || 5000;
      if (n < 2) return;
      var clone = slides[0].cloneNode(true); clone.removeAttribute('data-shopify-editor-block'); track.appendChild(clone);
      var dots = slides.map(function (_, k) {
        var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Imagem ' + (k + 1));
        d.onclick = function () { go(k); restart(); }; dotsBox.appendChild(d); return d;
      });
      function paint() { dots.forEach(function (d, k) { d.classList.toggle('on', k === i % n); }); }
      var copies = $$('[data-hero-copy]', hero);
      function copy() {
        copies.forEach(function (c, k) {
          var on = k === i % n; c.classList.toggle('on', on); c.setAttribute('aria-hidden', on ? 'false' : 'true');
          $$('a', c).forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
      }
      function go(k) { i = k; track.style.transform = 'translateX(-' + (i * 100) + '%)'; paint(); copy(); }
      function rewind() { track.classList.add('no-anim'); go(0); void track.offsetWidth; track.classList.remove('no-anim'); }
      track.addEventListener('transitionend', function () { if (i >= n) rewind(); });
      function next() { if (document.hidden) return; if (i >= n) rewind(); go(i + 1); }
      function restart() { clearInterval(timer); if (!paused && !REDUCED.matches) timer = setInterval(next, DELAY); }
      hero.addEventListener('focusin', function () { paused = true; restart(); });
      hero.addEventListener('focusout', function () { paused = false; restart(); });
      /* no personalizador: ao selecionar um bloco, mostra o slide dele */
      document.addEventListener('shopify:block:select', function (e) {
        var k = slides.indexOf(e.target); if (k > -1) { paused = true; go(k); restart(); }
      });
      go(0); restart();
    });
  }

  /* ══════════ VITRINE: abas + setas ══════════ */
  function initFeatured(root) {
    $$('[data-featured]', root).forEach(function (sec) {
      if (!once(sec, 'ok')) return;
      var row = $('[data-p-row]', sec), tabs = $$('[data-tab-btn]', sec);
      function filtrar(n) {
        $$('.p-card', row).forEach(function (c) {
          var t = (c.dataset.tab || 'all').split(' ');
          c.hidden = !(t.indexOf('all') > -1 || t.indexOf(String(n)) > -1);
        });
      }
      tabs.forEach(function (t) {
        t.onclick = function () {
          tabs.forEach(function (x) { x.classList.toggle('on', x === t); x.setAttribute('aria-selected', x === t); });
          filtrar(t.dataset.tabBtn); row.scrollTo({ left: 0, behavior: 'smooth' });
        };
      });
      if (tabs.length) filtrar(tabs[0].dataset.tabBtn); else filtrar(1);
      function step() { var c = $('.p-card:not([hidden])', row); return c ? c.offsetWidth + 16 : 300; }
      var p = $('.js-p-prev', sec), nx = $('.js-p-next', sec);
      if (p) p.onclick = function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); };
      if (nx) nx.onclick = function () { row.scrollBy({ left: step(), behavior: 'smooth' }); };
    });
  }

  /* ══════════ CARRINHO INTELIGENTE — 1 A 10 FRASCOS ══════════
     1, 2 e 3 frascos = variantes dos kits existentes.
     4 a 10 = kit de 3 (R$ 298,00) + variante "Frasco adicional" (R$ 99,33).
     Os valores são cobrados por variantes reais da Shopify.
     A B4You recebe o carrinho pelo checkout integrado, sem links externos.
  */
  var Cart = (function () {
    var drawer = $('#drawer'), list = $('#drItems'), foot = $('#drFoot');
    var MAX = 10, fila = Promise.resolve(), cache = {};
    function pedido(url, body) {
      var op = { headers: { Accept: 'application/json' } };
      if (body !== undefined) {
        op.method = 'POST'; op.headers['Content-Type'] = 'application/json';
        op.body = JSON.stringify(body);
      }
      return fetch(url, op).then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (d) {
          throw new Error(d.description || d.message || 'Não foi possível atualizar o carrinho.');
        });
        return r.json();
      });
    }
    function get() { return pedido(C.routes.cart + '.js'); }
    function kitsDe(handle) {
      if (!cache[handle]) {
        cache[handle] = pedido(C.routes.root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (p) { return p.variants || []; })
          .catch(function (e) { delete cache[handle]; throw e; });
      }
      return cache[handle];
    }
    function frascosTitulo(nome) {
      var t = String(nome || '').toLowerCase();
      if (/frasco\s+adicional|unidade\s+adicional|adicional\s+de\s+1\s+frasco/.test(t)) return 1;
      var m = t.match(/(?:^|\D)(10|[1-9])\s*frascos?\b/);
      return m ? Number(m[1]) : 0;
    }
    function adicional(v) { return /frasco\s+adicional|unidade\s+adicional/i.test(v.title || v.variant_title || ''); }
    function kitNumero(v) { return adicional(v) ? 0 : frascosTitulo(v.title || v.variant_title); }
    function conjunto(vs) {
      var kits = {};
      vs.forEach(function (v) { var n = kitNumero(v); if (n >= 1 && n <= 3 && !kits[n]) kits[n] = v; });
      return { kits: kits, extra: vs.find(adicional) };
    }
    function unidade(it) { return frascosTitulo(it.variant_title) || 0; }
    function itensDoProduto(cart, handle, conf) {
      var ids = Object.keys(conf.kits).map(function (k) { return Number(conf.kits[k].id); });
      if (conf.extra) ids.push(Number(conf.extra.id));
      return cart.items.filter(function (it) { return it.handle === handle && ids.indexOf(Number(it.variant_id)) !== -1; });
    }
    function total(itens) { return itens.reduce(function (n, it) { return n + unidade(it) * it.quantity; }, 0); }
    function disponivel(v) { if (!v || !v.available) throw new Error('Este kit está indisponível na Shopify.'); return v; }
    function destino(conf, quantidade) {
      if (quantidade < 0 || quantidade > MAX) throw new Error('O máximo é 10 frascos por pedido.');
      if (!quantidade) return [];
      if (quantidade <= 3) return [{ id: Number(disponivel(conf.kits[quantidade]).id), quantity: 1 }];
      if (!conf.extra) throw new Error('Cadastre a variante "Frasco adicional" com preço de R$ 99,33.');
      disponivel(conf.extra);
      return [
        { id: Number(disponivel(conf.kits[3]).id), quantity: 1 },
        { id: Number(conf.extra.id), quantity: quantidade - 3 }
      ];
    }
    function atualizar(cart, handle, conf, quantidade) {
      var itens = itensDoProduto(cart, handle, conf);
      var desejados = destino(conf, quantidade), valores = {};
      desejados.forEach(function (d) { valores[d.id] = d.quantity; });
      var atual = {};
      itens.forEach(function (it) { atual[it.variant_id] = (atual[it.variant_id] || 0) + it.quantity; });
      var diferente = Object.keys(atual).some(function (id) { return (valores[id] || 0) !== atual[id]; }) ||
        Object.keys(valores).some(function (id) { return (atual[id] || 0) !== valores[id]; });
      if (!diferente) return Promise.resolve(cart);
      // Atualiza as quantidades de todas as variantes dos kits sem tocar outros produtos.
      var updates = {};
      Object.keys(conf.kits).forEach(function (n) { updates[String(conf.kits[n].id)] = valores[conf.kits[n].id] || 0; });
      if (conf.extra) updates[String(conf.extra.id)] = valores[conf.extra.id] || 0;
      return pedido(C.routes.cart + '/update.js', { updates: updates }).then(function (novo) {
        var final = itensDoProduto(novo, handle, conf);
        var ok = total(final) === quantidade &&
          desejados.every(function (d) { return final.some(function (it) { return Number(it.variant_id) === d.id && it.quantity === d.quantity; }); });
        if (!ok) throw new Error('O carrinho não confirmou a alteração. Confira os kits cadastrados.');
        return novo;
      });
    }
    function abrir() {
      if (!drawer) { window.location.href = C.routes.cart; return; }
      drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function fechar() {
      if (!drawer) return;
      drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    function render(cart) {
      var n = cart.items.reduce(function (s, it) { return s + (unidade(it) || 1) * it.quantity; }, 0);
      $$('#cartCount, .cart-count').forEach(function (c) { c.textContent = n; c.classList.toggle('show', n > 0); });
      document.dispatchEvent(new CustomEvent('cell:cart', { detail: cart }));
      if (!list) return;
      if (foot) foot.hidden = !cart.item_count;
      if (!cart.item_count) {
        list.innerHTML = '<div class="dr-empty">' + C.strings.empty + '<br><a href="' + C.routes.allProducts + '" class="btn btn-dark">' + C.strings.shopNow + '</a></div>';
        return;
      }
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        var sub = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + it.variant_title + '</small>' : '';
        var isKit = !!unidade(it);
        // O controle +/− representa frascos totais, não somente a variante clicada.
        var cont = isKit ? '<div class="qty qty--kit" data-handle="' + it.handle + '"><button type="button" data-kit="-1" aria-label="Diminuir um frasco">−</button><span>' + (it.quantity * unidade(it)) + ' frasco(s)</span><button type="button" data-kit="1" aria-label="Adicionar um frasco">+</button></div>' :
          '<div class="qty"><button type="button" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '">+</button></div>';
        return '<div class="dr-item" data-key="' + it.key + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><a href="' + it.url + '"><h4>' + it.product_title + '</h4></a>' + sub + cont + '</div>' +
          '<div class="pr">' + money(it.final_line_price) + '<button type="button" class="rm" data-remove-kit="' + (isKit ? '1' : '0') + '" data-q="0">' + C.strings.remove + '</button></div></div>';
      }).join('');
      if ($('#drTotal')) $('#drTotal').textContent = money(cart.total_price);
      if ($('#drParc')) $('#drParc').textContent = parcelaTxt(cart.total_price);
      $$('.qty--kit', list).forEach(function (q) {
        kitsDe(q.dataset.handle).then(function (vs) {
          var conf = conjunto(vs), atual = total(itensDoProduto(cart, q.dataset.handle, conf));
          var minus = $('button[data-kit="-1"]', q);
          if (minus) minus.disabled = atual <= 0;
          // Deixa o + clicável em 10 para exibir a mensagem de limite.
        }).catch(function () {});
      });
    }
    function refresh() { return get().then(function (c) { render(c); return c; }); }
    function localizar(id, cart) {
      var item = cart.items.find(function (it) { return Number(it.variant_id) === Number(id); });
      if (item) return Promise.resolve({ handle: item.handle, quantidade: unidade(item) });
      // Resolve variantes mesmo quando o carrinho estiver completamente vazio.
      return pedido(C.routes.root + 'variants/' + encodeURIComponent(id) + '.js')
        .then(function (v) { return { handle: v.product_handle || '', quantidade: frascosTitulo(v.title), productId: v.product_id }; });
    }
    function handleDeVariante(id, info) {
      if (info.handle) return Promise.resolve(info.handle);
      // A variante JSON não garante product_handle: usa o produto atualmente exibido.
      var dom = document.querySelector('.pk[data-variant="' + id + '"]');
      var caminho = dom && dom.closest('[data-pdp2]');
      var link = caminho && document.querySelector('link[rel="canonical"]');
      if (link) {
        var match = link.href.match(/\/products\/([^/?#]+)/);
        if (match) return Promise.resolve(match[1]);
      }
      var produtos = Array.from(document.querySelectorAll('a[href*="/products/"]')).map(function (a) {
        var m = a.href.match(/\/products\/([^/?#]+)/); return m && m[1];
      }).filter(Boolean);
      return Promise.all(Array.from(new Set(produtos)).map(function (h) { return kitsDe(h).then(function (vs) {
        return vs.some(function (v) { return Number(v.id) === Number(id); }) ? h : null;
      }).catch(function () { return null; }); })).then(function (xs) { return xs.find(Boolean) || ''; });
    }
    function adicionar(id, qty) {
      qty = Math.max(1, parseInt(qty, 10) || 1);
      return get().then(function (cart) {
        return localizar(id, cart).then(function (info) {
          if (!info.quantidade) return pedido(C.routes.cartAdd + '.js', { items: [{ id: Number(id), quantity: qty }] });
          return handleDeVariante(id, info).then(function (handle) {
            if (!handle) throw new Error('Não foi possível identificar o produto do kit.');
            return kitsDe(handle).then(function (vs) {
              var conf = conjunto(vs), atual = total(itensDoProduto(cart, handle, conf));
              var alvo = atual + info.quantidade * qty;
              if (alvo > MAX) throw new Error('O máximo é 10 frascos por pedido.');
              return atualizar(cart, handle, conf, alvo);
            });
          });
        });
      }).then(function () { return refresh(); }).then(function () { toast(C.strings.added); abrir(); });
    }
    function enfileirar(fn) {
      var job = fila.then(fn);
      fila = job.catch(function () {});
      return job.catch(function (e) { toast(e.message || C.strings.error); abrir(); return refresh(); });
    }
    function add(id, qty) { return enfileirar(function () { return adicionar(id, qty); }); }
    function alterarKit(handle, delta, remover) {
      return enfileirar(function () {
        return Promise.all([get(), kitsDe(handle)]).then(function (dados) {
          var cart = dados[0], conf = conjunto(dados[1]);
          var atual = total(itensDoProduto(cart, handle, conf));
          var alvo = remover ? 0 : atual + delta;
          if (alvo > MAX) throw new Error('O máximo é 10 frascos por pedido.');
          return atualizar(cart, handle, conf, alvo).then(refresh).then(abrir);
        });
      });
    }
    function change(key, qty) {
      return enfileirar(function () { return pedido(C.routes.cartChange + '.js', { id: key, quantity: qty }).then(refresh); });
    }
    if (list) list.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-kit], button[data-q]');
      if (!b) return;
      var item = b.closest('.dr-item'), kit = item && $('.qty--kit', item);
      if (kit) { b.disabled = true; alterarKit(kit.dataset.handle, Number(b.dataset.kit || 0), !!b.dataset.removeKit && b.dataset.removeKit === '1'); return; }
      if (b.hasAttribute('data-q')) change(item.dataset.key, Number(b.dataset.q));
    });
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.js-add[data-variant-id]');
      if (addBtn) { e.preventDefault(); addBtn.disabled = true; add(addBtn.dataset.variantId, 1).then(function () { addBtn.disabled = false; }); return; }
      var o = e.target.closest('.js-cart-open');
      if (o && drawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); refresh().then(abrir); return; }
      if (e.target.closest('.js-cart-close')) fechar();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('.js-product-form');
      if (!f || !drawer) return;
      e.preventDefault();
      var input = f.querySelector('[name="id"]'); if (!input) return;
      var qty = parseInt((f.querySelector('[name="quantity"]') || {}).value, 10) || 1;
      var btn = f.querySelector('[data-buy]'); if (btn) btn.disabled = true;
      add(input.value, qty).then(function () { if (btn) btn.disabled = false; });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    if (list) refresh();
    return { open: abrir, close: fechar, add: add, refresh: refresh };
  })();
  window.CellCart = Cart;

  /* ══════════ CARRINHO: cronômetro, meta de frascos com barra e cupom ══════════ */
  (function () {
    var timer = $('[data-cart-timer]'), goal = $('[data-cart-goal]'), cup = $('[data-cupom]');
    function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
    /* cronômetro: conta a partir do primeiro item no carrinho e recomeça quando zera */
    var tick = null;
    function relogio() {
      if (!timer) return;
      var total = (parseInt(timer.dataset.min, 10) || 10) * 60, t0 = parseInt(store('cell-cart-t0'), 10);
      if (!t0) { t0 = Date.now(); store('cell-cart-t0', String(t0)); }
      var resta = total - Math.floor((Date.now() - t0) / 1000);
      if (resta <= 0) { store('cell-cart-t0', String(Date.now())); resta = total; }
      var m = Math.floor(resta / 60), sec = resta % 60;
      $('[data-timer]', timer).textContent = (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    }
    function frascos(cart) {
      return cart.items.reduce(function (n, it) { var m = String(it.variant_title || '').match(/\d+/); return n + (m ? parseInt(m[0], 10) : 1) * it.quantity; }, 0);
    }
    document.addEventListener('cell:cart', function (e) {
      var cart = e.detail, cheio = cart.item_count > 0;
      if (timer) {
        timer.hidden = !cheio;
        if (cheio && !tick) { relogio(); tick = setInterval(relogio, 1000); }
        if (!cheio) { clearInterval(tick); tick = null; store('cell-cart-t0', null); }
      }
      if (goal) {
        goal.hidden = !cheio; if (!cheio) return;
        var n = Math.min(frascos(cart), 3), tpl = $('template[data-goal="' + Math.max(n, 1) + '"]', goal);
        $('[data-goal-msg]', goal).innerHTML = tpl ? tpl.innerHTML : '';
        $$('.dr-goal-bar > span', goal).forEach(function (sp, i) { sp.classList.toggle('on', i < n); });
      }
    });
    /* cupom: guardado na sessão e enviado ao checkout */
    if (cup) {
      var inp = $('[data-cupom-input]', cup), msg = $('[data-cupom-msg]', cup);
      function mostra() {
        var c = store('cell-cupom');
        msg.hidden = !c; inp.value = c || '';
        if (c) msg.innerHTML = 'Cupom <b>' + c.replace(/[<>&"]/g, '') + '</b> será aplicado no pagamento. <button type="button" data-cupom-del>Remover</button>';
      }
      function aplica() {
        var c = inp.value.trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '');
        if (!c) { inp.focus(); return; }
        store('cell-cupom', c); mostra();
      }
      $('[data-cupom-apply]', cup).addEventListener('click', aplica);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); aplica(); } });
      cup.addEventListener('click', function (e) { if (e.target.closest('[data-cupom-del]')) { store('cell-cupom', null); mostra(); inp.focus(); } });
      mostra();
      document.addEventListener('cell:cart', mostra);
    }
  })();

  /* Checkout: segue o fluxo nativo da Shopify, conectado à B4You.
     Nenhum redirecionamento externo é interceptado por este script. */

  /* ══════════ MEGA MENU "PRODUTOS" ══════════
     Desktop (>= 900px): abre ao passar o mouse ou clicar; fecha ao sair com
     o mouse (com tolerância), Esc, clique fora ou em link. */
  function initMega(root) {
    var gatilho = $('[data-mega-abrir]', root), mega = $('[data-mega]', root);
    if (!gatilho || !mega || !once(mega, 'ok')) return;
    var header = $('.site-header'), timer = null, computador = window.matchMedia('(min-width: 900px)');
    function medirTopo() { document.documentElement.style.setProperty('--mega-top', Math.round(header.getBoundingClientRect().bottom) + 'px'); }
    function aberto() { return mega.classList.contains('aberto'); }
    function abrir() { if (!computador.matches) return; clearTimeout(timer); medirTopo(); mega.classList.add('aberto'); mega.setAttribute('aria-hidden', 'false'); gatilho.setAttribute('aria-expanded', 'true'); }
    function fechar() { clearTimeout(timer); mega.classList.remove('aberto'); mega.setAttribute('aria-hidden', 'true'); gatilho.setAttribute('aria-expanded', 'false'); }
    function fecharDepois() { clearTimeout(timer); timer = setTimeout(fechar, 180); }
    gatilho.addEventListener('mouseenter', abrir);
    gatilho.addEventListener('mouseleave', fecharDepois);
    mega.addEventListener('mouseenter', function () { clearTimeout(timer); });
    mega.addEventListener('mouseleave', fecharDepois);
    gatilho.addEventListener('focus', abrir);
    gatilho.addEventListener('click', function (e) { if (computador.matches) { e.preventDefault(); aberto() ? fechar() : abrir(); } });
    mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget) && e.relatedTarget !== gatilho) fechar(); });
    mega.addEventListener('click', function (e) { if (e.target.closest('a[href]')) fechar(); });
    document.addEventListener('click', function (e) { if (aberto() && !mega.contains(e.target) && !gatilho.contains(e.target)) fechar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
    window.addEventListener('scroll', function () { if (aberto()) medirTopo(); }, { passive: true });
    window.addEventListener('resize', function () { if (!computador.matches) fechar(); else if (aberto()) medirTopo(); });

    /* vitrine: a categoria sob o mouse/foco mostra o grupo de produtos dela */
    var itens = $$('[data-mostrar]', mega), titulo = $('[data-vitrine-titulo]', mega), grupos = $$('[data-grupo]', mega);
    function mostrar(item) {
      var alvo = item ? item.dataset.mostrar : '0';
      itens.forEach(function (i) { i.classList.toggle('ativo', i === item); });
      grupos.forEach(function (g) { g.hidden = g.dataset.grupo !== alvo; });
      if (titulo) titulo.textContent = item ? item.dataset.titulo : titulo.dataset.padrao;
    }
    itens.forEach(function (item) {
      item.addEventListener('mouseenter', function () { mostrar(item); });
      item.addEventListener('focusin', function () { mostrar(item); });
    });
    mostrar(null);
    /* no personalizador: selecionar um bloco de categoria abre o mega nela */
    document.addEventListener('shopify:block:select', function (e) {
      var a = e.target.querySelector && e.target.querySelector('[data-mostrar]');
      if (a && mega.contains(a)) { abrir(); mostrar(a); }
    });
  }

  /* ══════════ MENU MOBILE ══════════ */
  function initMobileMenu(root) {
    var m = $('#mnav', root), btn = $('.js-menu', root);
    if (!m || !btn || !once(m, 'ok')) return;
    btn.onclick = function () { m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); };
    $$('.js-menu-close', m).forEach(function (x) {
      x.addEventListener('click', function () { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); });
    });
  }

  /* ══════════ POPUP DE CUPOM + ABA LATERAL ══════════ */
  function initPopup(root) {
    var m = $('#modal', root), tab = $('#sideTab', root);
    if (!m || !once(m, 'ok')) return;
    var KEY = 'cell-popup-oculto', VISTO = 'cell-popup-visto', FEITO = 'cell-cupom-feito', UTM = 'cell-utm';
    var editor = !!(window.Shopify && window.Shopify.designMode);
    function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} return null; }
    function etapa(n) { $$('.cupom-etapa', m).forEach(function (x) { var on = x.dataset.etapa === n; x.hidden = !on; if (on) x.classList.add('jogo-anima'); }); }
    function open(e) {
      if (e) e.preventDefault();
      if (ls(FEITO)) etapa('cupom');
      m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); ls(VISTO, String(Date.now()));
    }
    function close() { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); }
    $$('.js-modal-open', root).forEach(function (x) { x.onclick = open; });
    $$('.js-modal-close', m).forEach(function (x) { x.addEventListener('click', close); });
    /* kits do popup: guardam o cupom para o checkout e fecham o popup (o carrinho abre sozinho) */
    $$('.js-cupom-kit', m).forEach(function (b) {
      b.addEventListener('click', function () {
        try { if (m.dataset.cupomCode) sessionStorage.setItem('cell-cupom', m.dataset.cupomCode); } catch (e) {}
        close();
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    try { if (sessionStorage.getItem(KEY) && tab) tab.classList.add('hide'); } catch (e) {}
    var x = $('.js-side-close', root);
    if (x) x.onclick = function () { tab.classList.add('hide'); try { sessionStorage.setItem(KEY, '1'); } catch (e) {} };

    /* UTMs da visita: guardadas na 1ª página e repassadas aos links de compra e ao webhook */
    var utm = {};
    try { utm = JSON.parse(sessionStorage.getItem(UTM) || '{}'); } catch (e) {}
    var q = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'].forEach(function (k) { if (q.get(k)) utm[k] = q.get(k); });
    try { sessionStorage.setItem(UTM, JSON.stringify(utm)); } catch (e) {}
    $$('.js-utm', m).forEach(function (a) {
      try { var u = new URL(a.href); Object.keys(utm).forEach(function (k) { if (!u.searchParams.get(k)) u.searchParams.set(k, utm[k]); }); a.href = u.toString(); } catch (e) {}
    });

    /* abre sozinho ao rolar X% da página (uma vez a cada N dias; nunca depois do cadastro) */
    if (m.dataset.auto === 'true' && !editor && !ls(FEITO)) {
      var dias = parseFloat(m.dataset.dias) || 7, visto = parseInt(ls(VISTO), 10) || 0;
      if (Date.now() - visto > dias * 864e5) {
        var pct = (parseFloat(m.dataset.gatilho) || 35) / 100;
        var onScroll = function () {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          if (max > 0 && window.scrollY / max >= pct) {
            window.removeEventListener('scroll', onScroll);
            if (!document.querySelector('.modal.open, .drawer.open, .mnav.open, .qa-pop.open')) open();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }

    /* cadastro: nome + celular -> libera o cupom (e envia ao webhook, se houver) */
    var f = $('.js-cupom-form', m), tel = $('#cupomTel', m), erro = $('.cupom-erro', m);
    if (tel) tel.addEventListener('input', function () {
      var d = tel.value.replace(/\D/g, '').slice(0, 11), s = d;
      if (d.length > 2) s = '(' + d.slice(0, 2) + ') ' + d.slice(2);
      if (d.length > 7) s = '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length - 4) + '-' + d.slice(-4);
      tel.value = s;
    });
    if (f) f.addEventListener('submit', function (e) {
      e.preventDefault();
      var nome = $('#cupomNome', m).value.trim(), cel = tel.value.replace(/\D/g, '');
      if (nome.length < 2) { erro.textContent = 'Digite o seu nome.'; $('#cupomNome', m).focus(); return; }
      if (cel.length < 10) { erro.textContent = 'Digite o celular com DDD.'; tel.focus(); return; }
      erro.textContent = '';
      var hook = m.dataset.webhook;
      if (hook) {
        var dados = { nome: nome, celular: cel, origem: 'popup-cupom', pagina: window.location.href, data: new Date().toISOString() };
        Object.keys(utm).forEach(function (k) { dados[k] = utm[k]; });
        try { fetch(hook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(dados), keepalive: true }); } catch (err) {}
      }
      ls(FEITO, '1');
      etapa('cupom');
    });

    $$('.js-copiar', m).forEach(function (b) {
      b.onclick = function () {
        var c = b.dataset.codigo, ok = function () { b.textContent = 'Copiado!'; };
        if (navigator.clipboard) navigator.clipboard.writeText(c).then(ok, ok); else ok();
      };
    });
    if (editor) document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(m)) open(); });
  }

  /* ══════════ CARROSSÉIS (loop infinito + autoplay + arrasto) ══════════ */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (row) {
      if (!once(row, 'ok')) return;
      var originals = Array.prototype.slice.call(row.children), n = originals.length; if (n < 2) return;
      for (var s = 0; s < 2; s++) originals.forEach(function (el) {
        var c = el.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block');
        $$('[tabindex]', c).forEach(function (t) { t.removeAttribute('tabindex'); }); row.appendChild(c);
      });
      var host = row.closest('section') || row.parentElement, prev = $('.js-prev', host), next = $('.js-next', host),
        delay = parseInt(row.dataset.autoplay, 10) || 0, setW = 0, cardW = 0, dragging = false, moved = false, hovered = false, startX = 0, base = 0, t;
      function measure() { var a = row.children[0]; cardW = row.children[1].offsetLeft - a.offsetLeft; setW = row.children[n].offsetLeft - a.offsetLeft; }
      function normalize(soft) {
        if (!setW) return 0; var x = row.scrollLeft, lo = soft ? .5 : .06, hi = soft ? 1.5 : 1.94, d = 0;
        if (x < setW * lo) d = setW; else if (x > setW * hi) d = -setW; if (d) row.scrollLeft = x + d; return d;
      }
      function reset() { measure(); if (setW) row.scrollLeft = setW; }
      function go(dir) { normalize(true); row.scrollBy({ left: dir * cardW, behavior: 'smooth' }); }
      reset(); window.addEventListener('load', reset);
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(reset, 150); });
      row.addEventListener('scroll', function () { if (dragging) return; normalize(false); clearTimeout(t); t = setTimeout(function () { normalize(true); }, 140); }, { passive: true });
      if (prev) prev.onclick = function () { go(-1); };
      if (next) next.onclick = function () { go(1); };
      row.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch' || e.button !== 0) return; dragging = true; moved = false; startX = e.clientX; base = row.scrollLeft; row.classList.add('is-dragging'); });
      window.addEventListener('pointermove', function (e) { if (!dragging) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; row.scrollLeft = base - dx; base += normalize(true); });
      function end() { if (!dragging) return; dragging = false; row.classList.remove('is-dragging'); normalize(true); }
      window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);
      row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      if (delay) {
        host.addEventListener('mouseenter', function () { hovered = true; }); host.addEventListener('mouseleave', function () { hovered = false; });
        setInterval(function () { if (hovered || dragging || document.hidden || REDUCED.matches || row.querySelector('.is-playing')) return; go(1); }, delay);
      }
    });
  }

  /* ══════════ VÍDEOS: o iframe do YouTube só entra ao clicar ══════════ */
  function play(card) {
    if (!card || card.classList.contains('is-playing') || !card.dataset.yt) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + card.dataset.yt + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
    f.title = 'Depoimento em vídeo'; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.setAttribute('allowfullscreen', '');
    card.appendChild(f); card.classList.add('is-playing');
  }
  document.addEventListener('click', function (e) { var c = e.target.closest('.vid[data-yt]'); if (c) play(c); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var c = e.target.closest && e.target.closest('.vid[data-yt]'); if (c) { e.preventDefault(); play(c); }
  });

  /* ══════════ PÁGINA DE PRODUTO: galeria + kits (variantes) ══════════ */
  function initPdp(root) {
    $$('[data-pdp2]', root).forEach(function (pdp) {
      if (!once(pdp, 'ok')) return;
      var gal = $('[data-gallery]', pdp), slides = $$('.pg-slides img', gal), thumbs = $$('.pg-thumbs button', gal), gi = 0;
      function showImg(k) {
        if (!slides.length) return;
        gi = (k + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('on', i === gi); });
        thumbs.forEach(function (t, i) { t.classList.toggle('on', i === gi); });
      }
      thumbs.forEach(function (t, i) { t.onclick = function () { showImg(i); }; });
      var gp = $('.js-g-prev', gal), gn = $('.js-g-next', gal);
      if (gp) gp.onclick = function () { showImg(gi - 1); };
      if (gn) gn.onclick = function () { showImg(gi + 1); };
      var sx = null, main = $('.pg-main', gal);
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) showImg(gi + (dx < 0 ? 1 : -1)); sx = null; });
      /* fotos passando sozinhas; param ao passar o mouse e de vez quando a pessoa mexe na galeria */
      var gDelay = (parseInt(gal.dataset.autoplay, 10) || 0) * 1000, gHover = false, gStop = false;
      if (gDelay && slides.length > 1 && !REDUCED.matches) {
        gal.addEventListener('mouseenter', function () { gHover = true; });
        gal.addEventListener('mouseleave', function () { gHover = false; });
        gal.addEventListener('click', function (e) { if (e.isTrusted) gStop = true; });
        main.addEventListener('touchstart', function () { gStop = true; }, { passive: true });
        setInterval(function () {
          if (gHover || gStop || document.hidden) return;
          showImg(gi + 1);
          var th = thumbs[gi], row = th && th.parentElement;
          if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: th.offsetLeft - row.clientWidth / 2 + th.offsetWidth / 2, behavior: 'smooth' });
        }, gDelay);
      }

      var plans = $$('.pk', pdp), input = $('[data-variant-input]', pdp), buy = $('[data-buy]', pdp);
      var box = $('.pb-pricebox', pdp), deWrap = box && box.firstElementChild;
      var elDe = $('[data-de]', box), elPor = $('[data-por]', box), elOff = $('[data-off]', box), elCta = $('[data-cta-parc]', pdp);
      var kitImg = $('[data-kit-img]', gal), kitThumb = $('[data-kit-thumb]', gal), ladder = $$('[data-ladder] li', pdp);
      function pick(pk) {
        var d = pk.dataset;
        plans.forEach(function (p) { p.setAttribute('aria-checked', p === pk ? 'true' : 'false'); });
        if (input) input.value = d.variant;
        var form = buy && buy.form; if (form) { if (d.link) form.dataset.link = d.link; else delete form.dataset.link; }
        if (elPor) elPor.innerHTML = d.por;
        if (elDe) { elDe.innerHTML = d.de; if (deWrap) deWrap.hidden = !d.de; }
        if (elOff) { elOff.textContent = d.off + '% OFF'; elOff.hidden = !(+d.off > 0); }
        if (elCta) elCta.innerHTML = (C.parcelas || 12) + 'x ' + d.parcela;
        var bb = $('[data-buybar]'); if (bb) { $('[data-bb-parc]', bb).innerHTML = d.parcela; $('[data-bb-por]', bb).innerHTML = d.por; }
        if (buy) buy.disabled = d.available !== 'true';
        ladder.forEach(function (li) { li.classList.toggle('on', +li.dataset.step <= +d.qty); });
        if (kitImg && d.img) { kitImg.removeAttribute('srcset'); kitImg.src = d.img; if (kitThumb && d.thumb) kitThumb.src = d.thumb; }
        showImg(0);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', d.variant); window.history.replaceState({}, '', u); } catch (e) {}
      }
      plans.forEach(function (pk) { pk.addEventListener('click', function () { if (!pk.disabled) pick(pk); }); });
      /* barra de comprar fixa: aparece depois de X% da página e some enquanto o botão principal está na tela */
      var bar = $('[data-buybar]');
      if (bar && buy) {
        var limite = (parseInt(bar.dataset.show, 10) || 40) / 100, botaoVisivel = false;
        if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { botaoVisivel = en[0].isIntersecting; checa(); }).observe(buy);
        function checa() {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          var on = max > 0 && window.scrollY / max >= limite && !botaoVisivel;
          bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); document.body.classList.toggle('buybar-on', on);
        }
        window.addEventListener('scroll', checa, { passive: true }); checa();
        $('[data-bb-buy]', bar).addEventListener('click', function () { if (buy.form.requestSubmit) buy.form.requestSubmit(buy); else buy.click(); });
      }
      var start = $('.pk[aria-checked="true"]', pdp);
      if (start) {
        /* pinta a régua sem mexer na URL */
        ladder.forEach(function (li) { li.classList.toggle('on', +li.dataset.step <= +start.dataset.qty); });
      }
      pdp._pick = pick;
    });
  }

  /* ══════════ CALCULADORA DE KIT ══════════ */
  function initCalc(root) {
    $$('[data-calc]', root).forEach(function (calc) {
      if (!once(calc, 'ok')) return;
      var goals = $$('[data-goal]', calc), range = $('[data-days]', calc), out = $('[data-days-out]', calc),
        scale = $$('.calc-scale img', calc), res = $('[data-calc-result]', calc), rec = null;
      function paint() {
        var v = +range.value; range.style.setProperty('--fill', ((v - 30) / 60 * 100) + '%'); out.textContent = v;
        scale.forEach(function (im, i) { im.classList.toggle('on', i === v / 30 - 1); });
      }
      range.addEventListener('input', paint); paint();
      goals.forEach(function (g) { g.onclick = function () { goals.forEach(function (x) { x.classList.toggle('on', x === g); x.setAttribute('aria-checked', x === g); }); }; });
      $('.js-calc', calc).onclick = function () {
        var on = $('[data-goal].on', calc), goal = on ? +on.dataset.goal : 1, n = Math.max(goal, +range.value / 30);
        var kits = $$('.pk:not([disabled])');
        rec = kits.filter(function (k) { return +k.dataset.qty === n; })[0] ||
              kits.filter(function (k) { return +k.dataset.qty >= n; })[0] || kits[kits.length - 1];
        if (!rec) return;
        var d = rec.dataset;
        if (d.img) $('[data-res-img]', calc).src = d.thumb || d.img;
        $('[data-res-name]', calc).textContent = (+d.qty > 1 ? 'Kit ' + d.qty + ' frascos' : '1 frasco') + ' · ' + (+d.qty * 30) + ' dias';
        var tmp = document.createElement('div'); tmp.innerHTML = (C.parcelas || 12) + 'x ' + d.parcela + ' · ou ' + d.por + ' à vista';
        $('[data-res-price]', calc).textContent = tmp.textContent;
        res.hidden = false;
      };
      $('.js-calc-pick', calc).onclick = function () {
        if (!rec) return;
        rec.click();
        var c = document.getElementById('comprar'); if (c) c.scrollIntoView({ behavior: 'smooth' });
      };
    });
  }

  /* ══════════ AVALIAÇÕES COM ABAS ══════════ */
  function initRtabs(root) {
    $$('[data-rtabs]', root).forEach(function (sec) {
      if (!once(sec, 'ok')) return;
      var btns = $$('[data-rt]', sec), items = $$('[data-rt-item]', sec);
      btns.forEach(function (b) { b.onclick = function () {
        btns.forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-selected', x === b); });
        items.forEach(function (it) { it.hidden = it.dataset.rtItem !== b.dataset.rt; });
      }; });
    });
  }

  /* ══════════ RESPOSTAS RÁPIDAS (texto ou vídeo em formato de stories) ══════════ */
  (function () {
    var lista = [], atual = 0;
    function pop() { return $('[data-qa-pop]'); }
    function close() {
      var p = pop(); if (!p) return;
      p.classList.remove('open', 'qa-pop--story'); p.setAttribute('aria-hidden', 'true');
      var v = $('[data-qa-pop-video]', p); if (v) { v.innerHTML = ''; v.hidden = true; }
      document.body.style.overflow = '';
    }
    function story(k) {
      var p = pop(); atual = (k + lista.length) % lista.length;
      var s = lista[atual], vid = $('[data-qa-pop-video]', p), bars = $('[data-qa-bars]', p);
      $('[data-qa-pop-title]', p).textContent = s.dataset.qaTitle;
      $('[data-qa-pop-text]', p).textContent = s.dataset.qaText;
      bars.innerHTML = lista.map(function (_, i) { return '<i class="' + (i < atual ? 'done' : i === atual ? 'on' : '') + '"></i>'; }).join('');
      vid.hidden = false;
      vid.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + s.dataset.qaYt + '?autoplay=1&playsinline=1&rel=0&modestbranding=1&controls=0" title="' + s.dataset.qaTitle.replace(/"/g, '') + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      $$('[data-qa-nav]', p).forEach(function (b) { b.hidden = lista.length < 2; });
    }
    document.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-qa-nav]');
      if (nav) { story(atual + parseInt(nav.dataset.qaNav, 10)); return; }
      var s = e.target.closest('[data-qa]');
      if (s) {
        var p = pop(); if (!p) return;
        var img = $('[data-qa-pop-img]', p), vid = $('[data-qa-pop-video]', p);
        if (s.dataset.qaYt) {
          /* stories: navega entre as bolinhas que têm vídeo, na mesma fileira */
          var grupo = s.closest('.stories') || document;
          lista = $$('[data-qa]', grupo).filter(function (x) { return x.dataset.qaYt; });
          img.hidden = true; p.classList.add('qa-pop--story');
          story(lista.indexOf(s));
        } else {
          p.classList.remove('qa-pop--story');
          $('[data-qa-pop-title]', p).textContent = s.dataset.qaTitle;
          $('[data-qa-pop-text]', p).textContent = s.dataset.qaText;
          img.hidden = false; img.src = s.dataset.qaImg; vid.hidden = true; vid.innerHTML = '';
        }
        p.classList.add('open'); p.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('.js-qa-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      var p = pop(); if (!p || !p.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (p.classList.contains('qa-pop--story') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) story(atual + (e.key === 'ArrowRight' ? 1 : -1));
    });
  })();

  /* ══════════ REVELAR AO ROLAR ══════════ */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { threshold: .15 }) : null;
  /* fade-in leve ao rolar: cada seção abaixo da dobra aparece uma vez por visita à página.
     Ao voltar para a página (ex.: produto → home), o fade acontece de novo. */
  function initReveal(root) {
    if (!io || (window.Shopify && window.Shopify.designMode)) { $$('.rv', root).forEach(function (e) { e.classList.add('in'); }); return; }
    var main = $('#MainContent');
    if (main && window.innerHeight > 0 && (root === document || main.contains(root))) {
      $$('#MainContent > .shopify-section').forEach(function (sec, i) {
        if (i === 0 || sec.classList.contains('rv-sec')) return;
        if (sec.getBoundingClientRect().top > window.innerHeight * 0.92) sec.classList.add('rv', 'rv-sec');
      });
    }
    $$('.rv', root).forEach(function (e) { if (!e.classList.contains('in')) io.observe(e); });
  }
  /* voltou pelo botão "voltar" (página restaurada do cache): refaz o fade do que está fora da tela */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !io) return;
    $$('.rv.in').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top > window.innerHeight || r.bottom < 0) { el.classList.remove('in'); io.observe(el); }
    });
  });

  /* ══════════ LOGIN: mostrar "recuperar senha" ══════════ */
  function initAccount(root) {
    $$('.js-recover', root).forEach(function (a) {
      a.onclick = function (e) { e.preventDefault(); var r = $('#recover'); if (r) { r.classList.add('open'); r.scrollIntoView({ behavior: 'smooth' }); } };
    });
    if (window.location.hash === '#recover') { var r = $('#recover'); if (r) r.classList.add('open'); }
  }


  /* ══════════ BUSCA EM PAINEL (pílula + resultados ao digitar) ══════════ */
  function initBusca(root) {
    var b = $('[data-busca]', root); if (!b || !once(b, 'ok')) return;
    var input = $('[data-busca-input]', b), limpar = $('[data-busca-limpar]', b), inicio = $('[data-busca-inicio]', b),
      res = $('[data-busca-res]', b), lista = $('[data-busca-lista]', b), todos = $('[data-busca-todos]', b), t, ultimo = '';
    function abrir(e) {
      if (e) e.preventDefault();
      b.classList.add('open'); b.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 60);
    }
    function fechar() { b.classList.remove('open'); b.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    $$('.js-busca-abrir').forEach(function (a) { a.addEventListener('click', abrir); });
    $$('.js-busca-fechar', b).forEach(function (x) { x.addEventListener('click', fechar); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && b.classList.contains('open')) fechar();
      if (e.key === '/' && !b.classList.contains('open') && !/input|textarea|select/i.test(document.activeElement.tagName)) abrir(e);
    });
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function urlBusca(q) { return C.routes.search + '?type=product&q=' + encodeURIComponent(q); }
    function mostrar(q) {
      limpar.hidden = !q;
      if (q.length < 2) { res.hidden = true; inicio.hidden = false; return; }
      todos.href = urlBusca(q);
      ultimo = q;
      fetch(C.routes.suggest + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== ultimo) return;
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          inicio.hidden = true; res.hidden = false;
          lista.innerHTML = ps.length ? ps.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            var preco = Math.round(parseFloat(p.price_min || p.price) * 100);
            return '<a href="' + esc(p.url) + '" class="busca-item">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
              '<b>' + esc(p.title) + '</b><span class="busca-preco">' + (isNaN(preco) ? '' : money(preco)) + '</span></a>';
          }).join('') : '<p class="busca-vazio">Nenhum produto encontrado para “' + esc(q) + '”.</p>';
        }).catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(t); var q = input.value.trim(); t = setTimeout(function () { mostrar(q); }, 180); });
    limpar.addEventListener('click', function () { input.value = ''; mostrar(''); input.focus(); });
    $$('[data-termo]', b).forEach(function (c) { c.addEventListener('click', function (e) { e.preventDefault(); input.value = c.dataset.termo; mostrar(c.dataset.termo); input.focus(); }); });
  }

  function initAll(root) {
    initAnnounce(root); initHero(root); initFeatured(root); initMega(root); initMobileMenu(root);
    initPopup(root); initBusca(root); initCarousels(root); initPdp(root); initCalc(root); initRtabs(root); initReveal(root); initAccount(root);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
